import { FlexContainer } from '@facephi/ui-react';
import styled from 'styled-components';

export const StyledAavatar = styled(FlexContainer)`
  img {
    border-radius: 100%;
    height: 2.4rem;
    aspect-ratio: 1/1;
    object-fit: cover;
  }
`;
